import React, { useEffect, useState } from 'react';
import { Bell, Save } from 'lucide-react';
import { toast } from 'react-toastify';
import { authAPI } from '../../config/auth-api';
import './Settings.css';

const AlertSettings = ({ adminData, setAdminData }) => {
  const [orderAlert, setOrderAlert] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const stored = adminData?.webAlerts || authAPI.getAdminData()?.webAlerts || {};
    setOrderAlert(stored.orderAlert !== false);
  }, [adminData]);

  const handleSave = async () => {
    const current = authAPI.getAdminData();
    if (!current?._id) {
      toast.error('Admin session not found');
      return;
    }

    try {
      setSaving(true);
      const webAlerts = {
        ...(current.webAlerts || {}),
        orderAlert: orderAlert !== false,
      };
      const response = await authAPI.updateAdmin(current._id, { webAlerts });
      if (!response.success) {
        toast.error(response.error || response.msg || 'Failed to save');
        return;
      }

      const updatedData = { ...current, webAlerts };
      localStorage.setItem('adminData', JSON.stringify(updatedData));
      if (typeof setAdminData === 'function') {
        setAdminData(updatedData);
      }
      toast.success('Alert settings saved');
    } catch (error) {
      toast.error('Failed to save alert settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <Bell size={18} />
        <h2>Order alerts</h2>
      </div>
      <div className="settings-card-content">
        <p className="settings-card-hint">
          Play a sound and show a toast when a new pending order arrives.
        </p>
        <div className="settings-alert-row">
          <span>Order alert</span>
          <label className="settings-toggle">
            <input
              type="checkbox"
              checked={orderAlert}
              onChange={(e) => setOrderAlert(e.target.checked)}
            />
            <span className="settings-slider" />
          </label>
        </div>
        <button
          type="button"
          className="settings-save-btn"
          onClick={handleSave}
          disabled={saving}
        >
          <Save size={16} />
          {saving ? 'Saving…' : 'Save alerts'}
        </button>
      </div>
    </div>
  );
};

export default AlertSettings;
